export const SERVICE_LIST = 'SERVICE_LIST'
export const SERVICE_CATEGORY_LIST = 'SERVICE_CATEGORY_LIST'
export const SHOP_DETAIL = 'SHOP_DETAIL'

export const ISLOADING = 'ISLOADING'